import React, { useEffect, useState } from "react";
import { Button, Card, Modal, Space, Table, TableProps, Tooltip } from "antd";
import {
  CheckCircleOutlined,
  CopyOutlined,
  HighlightOutlined,
} from "@ant-design/icons";
import { ShareIcon, UserCircleIcon } from "@heroicons/react/24/solid";
import { Folder } from "../../redux/interfaces/folder.types.ts";
import { Link } from "react-router-dom";

interface Props {
  folder: Folder;
}

export const ShareLink: React.FC<Props> = ({ folder }) => {
  const [copied, setCopied] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [link, setLink] = useState("");

  const copyIcon = !copied ? <CopyOutlined /> : <CheckCircleOutlined />;
  const copyMessage = !copied ? "Copiar Link" : "Link Copiado";

  const metadata = folder.metadata;
  const tenant = metadata?.tenant;
  const advisor = metadata?.advisor;

  const tableColumns: TableProps["columns"] = [
    {
      title: (
        <Space>
          <HighlightOutlined className="w-5 h-5 text-deep-orange-600" />
          <span className="flex justify-center">Folio</span>
        </Space>
      ),
      dataIndex: "folder_number",
      key: "folder_number",
      render: (_: any, { folder_number }) => (
        <div className="flex justify-center">{folder_number}</div>
      ),
    },
    {
      title: (
        <Space>
          <UserCircleIcon className="w-5 h-5 text-blue-600" />
          <span className="flex justify-center">Inquilino</span>
        </Space>
      ),
      dataIndex: "name",
      key: "name",
      render: (_: any, { name, tenant_email }) => (
        <div className="flex justify-center">
          <span>
            {name} - {tenant_email}
          </span>
        </div>
      ),
    },
    {
      title: (
        <Space>
          <UserCircleIcon className="w-5 h-5 text-green-600" />
          <span className="flex justify-center">Asesor</span>
        </Space>
      ),
      dataIndex: "advisor_name",
      key: "advisor_name",
      render: (_: any, { advisor_name, advisor_email }) => (
        <div className="flex justify-center">
          {advisor_name} - {advisor_email}
        </div>
      ),
    },
  ];

  const tableData = [
    {
      key: "1",
      folder_number: folder.folder_number,
      name: tenant?.full_name,
      tenant_email: tenant?.email,
      advisor_name: advisor?.full_name,
      advisor_email: advisor?.email,
    },
  ];

  useEffect(() => onSetLink(), [folder]);

  const onSetLink = () => {
    setLink(`${window.location.origin}/vault/${folder.id}`);
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 650);
    } catch (error) {
      console.error("Failed to copy link:", error);
    }
  };

  const onClosedModal = () => {
    setIsModalVisible(false);
  };

  const onOpenModal = () => {
    setIsModalVisible(true);
  };

  return (
    <div>
      <Modal
        title="Liga del cliente"
        open={isModalVisible}
        onCancel={onClosedModal}
        footer={null}
        width="auto"
        style={{ maxWidth: "40vw" }}
      >
        <Card className="w-full">
          <div className="flex items-center w-full overflow-hidden !border-none">
            <Tooltip title={copyMessage} className="cursor-pointer">
              <Button
                type="default"
                icon={copyIcon}
                className="rounded-none bg-transparent"
                style={{ border: "none" }}
                onClick={handleCopyLink}
              />
            </Tooltip>
            <Link to={link} target="_blank">
              <Button type="link" className="rounded-none !shadow-none">
                <span className="font-semibold text-ellipsis">{link}</span>
              </Button>
            </Link>
          </div>
          <div className="flex justify-center items-center w-full">
            <Table
              columns={tableColumns}
              dataSource={tableData}
              pagination={false}
            />
          </div>
        </Card>
      </Modal>
      <Tooltip title="Liga del cliente" className="cursor-pointer">
        <ShareIcon
          color="gray"
          className="h-6 w-6 text-gray-600 hover:text-blue-400"
          onClick={onOpenModal}
        />
      </Tooltip>
    </div>
  );
};
